import React from "react";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import BreadCrumb from '../../components/BreadCrumb';

const ERPDevelopment = () => {
    return (
        <div>
            <Navbar />
                <div class="container">
                    <BreadCrumb 
                        active_page="ERP Development" 
                        prev_sub_page={{
                            'link':'/services',
                            'text':'Services'
                        }}
                        sub_page={{
                            'link':'/services/it-development-consulting',
                            'text':'IT Development & Consulting'
                        }} 
                    />
                    <div class="inner-container">
                        <h2>ERP Development</h2>
                        <h3>Make Your Enterprise Future Ready</h3>
                        <p>Streamline your business operations, monitor financial activities and mould the date into actionable insights. We capitalize on the latest technology stacks and blend it well with the Domain and Functional expertise of our teams.</p>
                        <h3>Take Control Of Your Business</h3>
                        <img alt="" src={require('../../assets/images/services/erp.png')} width="100%"/>

                        <h3>ERP Adoption Phases</h3>
                        <h3>Preparation</h3>
                        <p>Includes consulting, identification of project scope, organizational strategies, existing business operations to fit with your specific business needs.</p>
                        <h3>Configuration</h3>
                        <p>We use 2 tier approach for designing that involves corporate and departmental levels. Each department would be focusing on its core business operations while all of them are also integrated into one unified platform.</p>
                        <h3>Customization</h3>
                        <p>We offer customizations & this feature is what would give your ERP a competitive niche over other organizations that would use a standardized ERP functionality.</p>
                        <h3>Extensions & Data Migration</h3>
                        <p>You can seamlessly transfer data from its primary sources into the newly adopted ERP systems. We thoroughly analyse every section of the data. This is followed by mapping the information to its location in the ERP database and data migration.</p>
                        <h3>User Training</h3>
                        <p>We design most user friendly UX/UI designs to make sure end user adopt it to most convenient and we extend end user trainings through user training manuals and visual interactive material</p>
                        <h3>Support</h3>
                        <p>We offer continuous support and provide you with maintenance services that would keep your ERP system functioning without any glitches.</p>
                        <h3>Add Value To Your Business</h3>
                        <ul>
                            <li>Cyber security</li>
                            <li>Automation</li>
                            <li>Data Centralization</li>
                            <li>Regulatory Compliances</li>
                            <li>Social Media Integration</li>
                            <li>Scalability</li>
                        </ul>
                    </div>
                </div>
            <Footer />
        </div>
    );
};

export default ERPDevelopment;